import { useTranslation } from "react-i18next";

/**
 * „Закрива се" на мястото на сумата в картата на масата (`TableCard`), докато
 * закриването чака фискалния принтер — модалът „Закрий" вече е затворен и
 * спинерът е тук. Тих етикет долу вдясно, без фон, със спинер отпред. Редът
 * държи височината на сумата, която замества, за да не мърда картата.
 * Пръстенът е малкото копие на някогашния голям спинер в модала (posRingDash
 * в index.css: дъгата „диша", обвивката се върти отделно).
 */
export function TableCardClosingLabel({ compact }: { compact: boolean }) {
  const { t } = useTranslation();
  // Линия ~1.3px при всеки размер: viewBox-ът е 104, пръстенът — 16/12px.
  const ringStroke = compact ? 11 : 9;
  return (
    <span
      className={`ml-auto flex min-w-0 items-center font-semibold leading-[1.2] text-pos-muted ${
        compact ? "h-[13px] gap-1 text-[11px]" : "h-[19px] gap-1.5 text-[13px]"
      }`}
    >
      <span
        className={`block shrink-0 animate-[spin_2.6s_linear_infinite] ${
          compact ? "h-3 w-3" : "h-4 w-4"
        }`}
      >
        <svg viewBox="0 0 104 104" className="block h-full w-full">
          <circle
            cx="52"
            cy="52"
            r="43"
            fill="none"
            strokeWidth={ringStroke}
            className="stroke-pos-accent/25"
          />
          <circle
            cx="52"
            cy="52"
            r="43"
            fill="none"
            strokeWidth={ringStroke}
            strokeLinecap="round"
            className="stroke-pos-accent animate-[posRingDash_2.2s_ease-in-out_infinite]"
          />
        </svg>
      </span>
      <span className="min-w-0 truncate">{t("ordering.tableClosing")}</span>
    </span>
  );
}
